import {AxiosResponse} from 'axios';
import i18next from "i18next";
import React, {ChangeEvent, createRef} from 'react';
import {Modal} from "react-bootstrap";
import {TFunction, withTranslation} from 'react-i18next';
import {DateObject} from "react-multi-date-picker";
import {toast} from "react-toastify";
import {DateHelper} from '../../helpers/DateHelper';
import {CurrencyHelper} from '../../helpers/CurrencyHelper';
import {OptionMapperHelper} from '../../helpers/OptionMapperHelper';
import {CurrencyOption} from "../../models/Currency";
import {IPageRequest} from '../../models/IPageRequest';
import {
    DateRangeType,
    IConciliationTotalsResponse,
    ISettlementTransaction,
    ISettlementTransactionRequest
} from "../../models/ISettlementData";
import {IShortcutCaptureResult} from "../../models/IShortcut";
import {IUserProfile} from '../../models/IUserProfile';
import {Option} from "../../models/Option";
import {SettlementService} from "../../services/SettlementService";
import {UtilService} from "../../services/UtilService";
import {WebCache} from '../../services/WebCache';
import CustomReCAPTCHA from '../CustomCaptcha';
import ErrorsView from '../ErrorsView';
import FormFilter, { FilterBlock } from '../containers/form-filterNew';
import Page from '../containers/pageNew';
import Button from '../controls/buttons/buttonNew';
import DateField from '../controls/fields/dateFieldNew';
import RadioButtonGroup from '../controls/fields/radioButtonGroupNew';
import SelectField from '../controls/fields/selectFieldNew';
import TextField from '../controls/fields/textFieldNew';
import TypeaheadField from '../controls/fields/typeaheadField';
import {
    actionColumnDefinition,
    ColumnDefinition,
    currencyColumnDefinition,
    dateColumnDefinition,
    numericColumnDefinition,
    percentageColumnDefinition,
    textColumnDefinition
} from '../table/ColumnDefinitionNew';
import {ReactComponent as SearchIconSVG} from "../../../node_modules/itd-common/assets/icons/search-icon.svg";
import CustomTable, {TableModeEnum} from '../table/CustomTableNew';
import "./PaymentsNew.scss";
import "./SettlementReport.css";
import FilterFiscalDocumentAndCommerce, {MultiSelectRef} from "../FilterFiscalDocumentAndCommerceNew";
import {IMessageContext} from "../MessagesContext";
import {withMessages} from "../contexts/MessagesContext";
import NavigationTabLinksForCalendar from './NavigationTabLinksForCalendar';
import CustomForm from '../containers/custom-form';
import { SmartTable } from '../table/SmartTable';
import {ReactComponent as SettlementNumberSVG} from "itd-common/assets/icons/settlement-number-filter.svg";
import { ReactComponent as BatchSVG } from 'itd-common/assets/icons/icon-folder.svg';
import { ReactComponent as CreditCardSVG } from 'itd-common/assets/icons/credit_card.svg';
import { ReactComponent as AuthorizationCodeSVG } from 'itd-common/assets/icons/authorization-code-filter.svg';
import { ReactComponent as GrossAmountSVG } from 'itd-common/assets/icons/gross-amount-filter.svg';
import { ReactComponent as QuotasSVG } from 'itd-common/assets/icons/quotas-filter.svg';
import { ReactComponent as IconPlus } from 'itd-common/assets/icons/icon-plus.svg';
import SideModal from '../containers/side-modal';
import DetailPaymentTransactionReport from './DetailPaymentTransactionReport';

interface IProps {
    settlementNumber: string | undefined,
    show: boolean,
    t: TFunction
    messages: IMessageContext
}

interface IState {
    dateRange: DateObject[],
    msg: string,
    activePage: number,
    mainPage: number,
    onlyVal:boolean,
    transactions: ISettlementTransaction[],
    errors: string[],
    filters:{
        fiscalDocument: string[],
        merchantNumber: string[],
    },
    currencyFilter:string,
    doQuery:boolean;
    dateRangeType: DateRangeType,
    currencyOptions: CurrencyOption[],
    trxToMerge:string,
    paymentToMerge:ISettlementTransaction|null,
    allStates:Option[],
    movementTypes:Option[],
    selectedStates:string,
    selectedMovementTypes:string,
    brandFilter: string,
    brandOptions: Option[],
    conciliationTotalResponse:IConciliationTotalsResponse,
    isCaptchaVerified: boolean,
    showModalCaptcha: boolean,
    pageRequest: IPageRequest,
    tableMode: TableModeEnum,
    pageSeing: string,
    currentUser: IUserProfile | null,
    maxDayRange: number,
    pages:number[],
    settlementNumberFilter: string,
    batchFilter: string,
    authorizationCodeFilter: string,
    cardNumberFilter: string,
    amountFilter: string,
    quotasFilter: string,
    showTransactionDetail: boolean,
    transactionDetail: ISettlementTransaction | null
}

const pageSize = 20;
const defaultPages = [1, 2, 3]
const pageQuantity = 3
const T_PREFIX: string = 'pages.calendar.';
let lastSettlementNumber: string | undefined = "";
// convierte "1.234,56" (formato es-UY) al formato crudo "1234.56" usado por grossAmount
const normalizeAmountSearch = (value: string): string => value.replace(/\./g, '').replace(',', '.');
class PaymentTransactionReport extends React.Component<IProps, IState> {
    private multiSelectRef = createRef<MultiSelectRef>();
    private optionMapper: OptionMapperHelper = new OptionMapperHelper(this.props.t);
    private columnDefinitions: Array<ColumnDefinition> = [];
    private DETAILSALEPAGE: string = "settlementVouchers";
    private doQuery: boolean = false;
    private messages: IMessageContext = this.props.messages;


    componentDidMount() {
        if (this.doQuery) {
            this.doQuery = false;
            this.getSettlementTransactions(null,this.state.activePage,this.state.mainPage)
        }
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.settlementNumber !== null && (nextProps.settlementNumber + "").length > 0 && lastSettlementNumber !== nextProps.settlementNumber) {
            lastSettlementNumber = nextProps.settlementNumber;
            this.setState({ ...this.state, doQuery:true }, this.initGrid);
        } else {
            this.getFromBuscar()
        }
    }

    initGrid = () => {
        return this.getSettlementTransactions(this.props.settlementNumber + "", 1,0);
    }

    buildDefaultDateRange = (): Array<DateObject> => {
        const currentDay: Date = new Date();
        const createDateObject: (day: number, month: number, year: number, hour: number, minute: number, second: number) => DateObject = (
            day: number, month: number, year: number, hour: number, minute: number, second: number
        ) => {
            let dateObject = new DateObject();
            dateObject.day = day;
            dateObject.month.index = month;
            dateObject.year = year;
            dateObject.hour = hour;
            dateObject.minute = minute;
            dateObject.second = second;
            return dateObject;
        };

        const firstWeekDay: Date = new Date(currentDay.setDate(currentDay.getDate() - currentDay.getDay()));
        let fromDate: DateObject = createDateObject(firstWeekDay.getDay() - 1, firstWeekDay.getMonth(), firstWeekDay.getFullYear(), 0, 0, 0);;

        const lastWeekDay: Date = new Date(currentDay.setDate(currentDay.getDate() - currentDay.getDay() + 6));
        let toDate: DateObject = createDateObject(lastWeekDay.getDay() - 1, lastWeekDay.getMonth(), lastWeekDay.getFullYear(), 23, 59, 59);

        return [fromDate, toDate];
    }

    buildConciliationTotalsInitializationObject = (): IConciliationTotalsResponse => {
        return {
            grossAmount: 0,
            grossAmountUSD: 0,
            conciliatedAmount: 0,
            conciliatedAmountUSD: 0,
            pendingAmount: 0,
            pendingAmountUSD: 0,
            totalSales: 0,
            totaMovements: 0,
            conciliatedPerc: 0
        };
    }

    buildColumnDefinition = (dateToShow: string) => {
        const currency: number = Number.parseInt(WebCache.getCurrencies()[0]?.id);
        const flagToYesNoFn = (flag: boolean) => {
            return flag ? i18next.t('yes') : i18next.t('no');
        };

        let conditionalDateColumnDefinition: ColumnDefinition;
        switch (dateToShow) {
            default:
            case "PAYMENT_DATE":
                conditionalDateColumnDefinition = dateColumnDefinition({ key: 'vtoDate', label: this.props.t('settlement-vtoDate'), header: true, percentageWidth: 10});
                break;
            case "PRESENTATION_DATE":
                conditionalDateColumnDefinition = dateColumnDefinition({ key: 'aggregationPresentationDate', label: this.props.t('settlement-aggregationPresentationDate'), header: true, percentageWidth: 10 });
                break;
            case "OPERATION_DATE":
                conditionalDateColumnDefinition = dateColumnDefinition({ key: 'authDate', label: this.props.t('settlement-authDate'), header: true, percentageWidth: 10 });
                break;
        }

        this.columnDefinitions = [
            conditionalDateColumnDefinition,
            numericColumnDefinition({ key: 'batch', label: this.props.t('settlement-batch'), header: true, percentageWidth: 10 }),
            numericColumnDefinition({ key: 'ticket', label: this.props.t('settlement-ticket'), header: true, percentageWidth: 10 }),
            textColumnDefinition({ key: 'cardNumber', label: this.props.t('settlement-cardNumber'), header: true, percentageWidth: 20 }),
            textColumnDefinition({ key: 'productCode', label: this.props.t('settlement-productCode'), header: true, percentageWidth: 10, filterKind: 'image',
                mapValue: (rowObject: ISettlementTransaction) => (
                    <img
                        alt={rowObject.productCode}
                        src={UtilService.getImageTag(rowObject.productCode?.toUpperCase())}
                        style={{ width: 56, height: 40, objectFit: "contain" }}
                    />                                
                )
            }),
            currencyColumnDefinition({ key: 'grossAmount', label: this.props.t('settlement-grossAmount'), currency, header: true, percentageWidth: 10,
                mapValue: (transaction: ISettlementTransaction) => `${CurrencyHelper.getCurrencyPrefix(transaction.currency)}${Intl.NumberFormat('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(transaction.grossAmount))}`
            }),
            numericColumnDefinition({ key: 'terminal', label: this.props.t('terminal'), header: true, percentageWidth: 10 }),
            textColumnDefinition({ key: 'currency', label: this.props.t('state'), header: true, mapValue: (transaction: ISettlementTransaction) => {
                    let className: string = '';
                    let labelKey: string = '';

                    if (transaction.settlementNumber) {
                        className = 'state-pill-success';
                        labelKey = 'payed';
                    }
                    else if (!(transaction.settlementNumber > 0 || new Date(transaction.originalPresentationDate) >= new Date())) {
                        className = 'state-pill-info';
                        labelKey = 'inprocess';
                    } else if (!(transaction.settlementNumber > 0 || new Date(transaction.originalPresentationDate) < new Date())) {
                        className = 'state-pill-warning';
                        labelKey = 'pending';
                    }

                    return <span key='li-state' className={`state-pill ${className}`}>{i18next.t(`${labelKey}`).toString()}</span>;
                }}),
            actionColumnDefinition({
                key: 'show',
                label: '',
                header: true,
                action: {
                    function: (rowObject: ISettlementTransaction) => {
                        this.showMoreDetails(rowObject);
                    },
                    icon: (rowObject: ISettlementTransaction) => {
                        return <IconPlus />
                    },
                },
            }),
            numericColumnDefinition({ key: 'settlementNumber', label: this.props.t('settlementNumber') }),
            textColumnDefinition({ key: 'merchantDocument', label:  WebCache.isUserUYU() ? this.props.t('merchantDocument'): this.props.t("merchantDocumentArg")}),
            textColumnDefinition({ key: 'merchantNumber', label: this.props.t('merchantNumber') }),
            numericColumnDefinition({ key: 'quotas', label: this.props.t('quotas'), mapValue: (transaction: ISettlementTransaction) => {
                    if(transaction.quotas==null||transaction.quotas==0||transaction.quotas==1)
                        return transaction.quotas+"";
                    if((transaction.currentQuota==0||transaction.currentQuota==1)&&(transaction.planQuotaType+"")!="1")
                        return transaction.quotas+"";
                    return transaction.currentQuota+"/"+transaction.quotas;
                } }),
            numericColumnDefinition({ key: 'planQuotaType', label: this.props.t('planQuoteType') }),
            numericColumnDefinition({ key: 'movementType', label: this.props.t('movementType'), mapValue: (transaction: ISettlementTransaction) => {
                    let movementType: string = '';

                    if (transaction.movementType === 5) {
                        movementType = transaction.reverseCode;
                    }
                    else {
                        const movementTypes: Array<Option> = i18next.t<Array<Option>>("movementTypes", { returnObjects: true });
                        const movementTypeOption: Option | undefined = movementTypes.find((movementTypeItem: Option) => Number(movementTypeItem.value) === transaction.movementType);
                        movementType = movementTypeOption?.label || '';
                    }

                    return movementType;
                } }),
            textColumnDefinition({ key: 'isQuotaPromotion', label: this.props.t('isQuotaPromotion'), mapValue: (transaction: ISettlementTransaction) => {
                    return flagToYesNoFn(transaction.isQuotaPromotion);
                }}),
            numericColumnDefinition({ key: 'authorizationCode', label: this.props.t('settlementAuthorizationCode') }),
            percentageColumnDefinition({ key: 'tariffPercentage', label: this.props.t('tariffPercentage') }),
            currencyColumnDefinition({ key: 'transactionTariffTaxAmount', label: this.props.t('transactionTariffTaxAmount'), currency }),
            currencyColumnDefinition({ key: 'transactionTaxTariffTaxAmount', label: this.props.t('transactionTaxTariffTaxAmount'), currency }),
            numericColumnDefinition({ key: 'planQuotaRate', label: this.props.t('planQuotaRate') }),
            currencyColumnDefinition({ key: 'financialCostAmount', label: this.props.t('financialCostAmount'), currency }),
            currencyColumnDefinition({ key: 'financialCostTaxAmount', label: this.props.t('taxCostAmount'), currency }),
            currencyColumnDefinition({ key: 'alícuotaIVAFO', label: this.props.t('alícuotaIVAFO'), currency }),
            percentageColumnDefinition({ key: 'directRatePercentage', label: this.props.t('directRatePercentage') }),
            currencyColumnDefinition({ key: 'directRateAmount', label: this.props.t('directRateAmount'), currency }),
            currencyColumnDefinition({ key: 'directRateTaxAmount', label: this.props.t('directRateTax'), currency }),
            textColumnDefinition({ key: 'isCampain', label: this.props.t('isCampain'), mapValue: (transaction: ISettlementTransaction) => {
                    return flagToYesNoFn(transaction.isCampain);
                }}),
            textColumnDefinition({ key: 'isCashback', label: this.props.t('isCashback'), mapValue: (transaction: ISettlementTransaction) => {
                    return flagToYesNoFn(transaction.isCashback);
                }}),
            textColumnDefinition({ key: 'id', label: this.props.t('isVal'), mapValue: (transaction: ISettlementTransaction) => {
                    return flagToYesNoFn(transaction.vtoDate !== transaction.originalVtoDate);
                }}),
            currencyColumnDefinition({ key: 'finAgp', label: this.props.t('finAgp'), currency }),
            numericColumnDefinition({key: 'invoiceNumber', label: this.props.t('invoiceNumber')})
        ];
    }

    constructor(props: IProps) {
        super(props);
        let shortcut: string = "";
        if(window.location.href.indexOf("shortcuts=") > 0) {
            shortcut = new URLSearchParams(window.location.href.substring(window.location.href.indexOf("shortcuts="))).get("shortcuts")+""
        }

        let trxToMerge: string = "";
        let dateRange: Array<DateObject> = DateHelper.buildDateRange();
        let currencyFilter: string = "";
        const allProducts= WebCache.getAllProducts(true)

        if(this.props.settlementNumber!=undefined)
            this.doQuery = true;

        if (shortcut != null && shortcut.length > 0) {
            this.doQuery = true;
            let shortcutDto: IShortcutCaptureResult[] = JSON.parse(shortcut);
            for (let shortcutDtoIndex = 0; shortcutDtoIndex < shortcutDto.length; shortcutDtoIndex++) {
                switch (shortcutDto[shortcutDtoIndex].type) {
                    case "TRX_TO_MERGE":
                        trxToMerge = shortcutDto[shortcutDtoIndex].data + "";
                        break;
                    case "DATE":
                        dateRange = [
                            new DateObject(shortcutDto[shortcutDtoIndex].data),
                            new DateObject(shortcutDto[shortcutDtoIndex].data)
                        ];
                        break;
                    case "CURRENCY":
                        currencyFilter = shortcutDto[shortcutDtoIndex].data + "";
                        break;
                }
            }
        }

        this.state = {
            onlyVal: false,
            dateRangeType: "PAYMENT_DATE",
            dateRange,
            msg: "",
            activePage: 1,
            mainPage: 0,
            transactions: [],
            errors: [],
            filters:{
                fiscalDocument: [""],
                merchantNumber:[""]
            },
            currencyFilter,
            pages:defaultPages,
            currencyOptions: UtilService.getCurrencyOptions(),
            brandFilter: allProducts[0].value,
            brandOptions:allProducts,
            doQuery: false,
            trxToMerge,
            paymentToMerge: null,
            allStates:[
                { key: "inprocess", label: i18next.t("inprocess"), value: "inprocess", disabled: false },
                { key: "pending", label: i18next.t("pending"), value: "pending", disabled: false },
                { key: "payed", label: i18next.t("payed"), value: "payed", disabled: false }
            ],
            selectedStates: "",
            movementTypes: i18next.t<Array<Option>>("movementTypes", { returnObjects: true }).map((movementType, movementTypeIndex) => {
                // valores de "Cupón", "Cupón Crédito", "Cupón presentación" y "Cupón Rechazado" usan el icono de tarjeta
                const couponValues = ["0", "1", "4", "11"];
                // valores de "Cargo" y "Pago" usan el icono de monto
                const amountValues = ["2", "3"];
                // valores de "Contracargo" y "Reversion de Compra" usan el icono de cuotas
                const quotasValues = ["9", "13"];
                // valores de "Contrapartida", "Contrapartida-Ajustes", "Contrapartida-Promociones" y "Contrapartida DA" usan el icono de batch
                const batchValues = ["5", "8", "10", "12"];
                // valor de "Impuestos" usa el icono de codigo de autorizacion
                const authorizationCodeValues = ["6"];
                // valor de "Representaciones Manuales" usa el icono de numero de liquidacion
                const settlementNumberValues = ["7"];
                const movementValue = String(movementType.value);
                const IconComponent = couponValues.includes(movementValue) ? CreditCardSVG
                    : amountValues.includes(movementValue) ? GrossAmountSVG
                    : quotasValues.includes(movementValue) ? QuotasSVG
                    : batchValues.includes(movementValue) ? BatchSVG
                    : authorizationCodeValues.includes(movementValue) ? AuthorizationCodeSVG
                    : settlementNumberValues.includes(movementValue) ? SettlementNumberSVG
                    : null;
                return {
                    key: String(movementTypeIndex),
                    ...movementType,
                    label: (<>{IconComponent && <IconComponent style={{ marginRight: 8, width: 16, height: 16, verticalAlign: 'middle' }} />}{movementType.label}</>) as unknown as string,
                    disabled: false
                };
            }),
            selectedMovementTypes: "",
            conciliationTotalResponse: this.buildConciliationTotalsInitializationObject(),
            isCaptchaVerified: sessionStorage.getItem('captchaVerified')=="true",
            showModalCaptcha: false,
            tableMode: TableModeEnum.LIST,
            pageRequest: {
                Skip: 0,
                Take: 0
            },
            pageSeing: "",
            currentUser : WebCache.getCurrentUser(),
            maxDayRange:30,
            settlementNumberFilter: '',
            batchFilter: '',
            authorizationCodeFilter: '',
            cardNumberFilter: '',
            amountFilter: '',
            quotasFilter: '',
            showTransactionDetail: false,
            transactionDetail: null
        }
        this.buildColumnDefinition("PAYMENT_DATE");
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
        let thatPage: string = window.location.href.split("/")[window.location.href.split("/").length-1];
        if(this.state.pageSeing != thatPage)
            this.setState({...this.state, pageSeing: thatPage})
    }

    getFromBuscar = () => {
        this.setState({
            ...this.state, activePage: 1, mainPage: 0
        }, ()=>{
            this.getSettlementTransactions(null, this.state.activePage, this.state.mainPage);
        });
    }

    clearFilters = () => {
        this.multiSelectRef.current?.clearFilters();
        this.setState({
            ...this.state,
            dateRange: DateHelper.buildDateRange(),
            currencyFilter: "",
            filters:{
                fiscalDocument: [""],
                merchantNumber:[""]
            },
            selectedStates: "",
            selectedMovementTypes: "",
            brandFilter: "",
            settlementNumberFilter: '',
            batchFilter: '',
            authorizationCodeFilter: '',
            cardNumberFilter: '',
            amountFilter: '',
            quotasFilter: '',
            activePage: 1,
            mainPage: 0
        }, ()=> {
            this.getSettlementTransactions(null,this.state.activePage,this.state.mainPage)
        });
    }

    getSettlementTransactionsRequest = (all: boolean): ISettlementTransactionRequest => {
        let fromDate: string = '';
        let toDate: string = '';

        if (this.state.dateRange[0]) {
            let from_year = this.state.dateRange[0].year;
            let from_month = this.state.dateRange[0].month.number;
            let from_day = this.state.dateRange[0].day;
            fromDate = new Date(from_year, from_month - 1, from_day).toJSON();
        }

        if (this.state.dateRange[1]) {
            let to_year = this.state.dateRange[1].year;
            let to_month = this.state.dateRange[1].month.number;
            let to_day = this.state.dateRange[1].day;
            toDate = new Date(to_year, to_month - 1, to_day).toJSON();
        }

        if (this.props.settlementNumber === undefined) {
            return {
                From: fromDate,
                To: toDate,
                DateRangeType: this.state.dateRangeType,
                MerchantDocument: this.state.filters.fiscalDocument.includes("all") ? [] : this.state.filters.fiscalDocument.filter(x=>x.length>0),
                MerchantNumber: this.state.filters.merchantNumber.includes("all")? [] : this.state.filters.merchantNumber.filter(x=>x.length>0),
                SettlementNumber: (this.state.settlementNumberFilter == null || this.state.settlementNumberFilter == "") ? "" : this.state.settlementNumberFilter,
                Ticket: "",
                Batch: (this.state.batchFilter == null || this.state.batchFilter == "") ? "" : this.state.batchFilter,
                Quotas: (this.state.quotasFilter == null || this.state.quotasFilter == "") ? "" : this.state.quotasFilter,
                States: this.state.selectedStates ? [this.state.selectedStates] : [],
                MovementTypes: this.state.selectedMovementTypes ? [Number.parseInt(this.state.selectedMovementTypes)] : [],
                AuthorizationCode: (this.state.authorizationCodeFilter == null || this.state.authorizationCodeFilter == "") ? "" : this.state.authorizationCodeFilter,
                TerminalId: "",
                CardNumber: (this.state.cardNumberFilter == null || this.state.cardNumberFilter == "") ? "" : this.state.cardNumberFilter,
                Currency: (this.state.currencyFilter === null || this.state.currencyFilter === "") ? "" : this.state.currencyFilter,
                OnlyVal: this.state.onlyVal,
                Skip: all ? 0 : (this.state.mainPage * pageSize * pageQuantity),
                Take: all ? 0 : ((pageSize * pageQuantity) + 1),
                Brand:  this.state.brandFilter.replace("productCode-", ""),
                Amount: (this.state.amountFilter == null || this.state.amountFilter == "") ? "" : normalizeAmountSearch(this.state.amountFilter),
            };
        } else {
            return {
                DateRangeType: this.state.dateRangeType,
                SettlementNumber: this.props.settlementNumber,
                Ticket: "",
                Batch: "",
                Quotas: "",
                AuthorizationCode: "",
                Currency: "",
                OnlyVal: this.props.settlementNumber!=undefined?null:this.state.onlyVal,
                TerminalId: "",
                Skip: all ? 0 : (this.state.mainPage * pageSize * pageQuantity),
                Take: all ? 0 : ((pageSize * pageQuantity) + 1),
                Brand: this.state.brandFilter,
                MerchantDocument: this.state.filters.fiscalDocument.includes("all") ? [] : this.state.filters.fiscalDocument.filter(x=>x.length>0),
                MerchantNumber: this.state.filters.merchantNumber.includes("all")? [] : this.state.filters.merchantNumber.filter(x=>x.length>0)
            };
        }
    }

    getSettlementTransactions = (lastSettlementNumber:string|null,activePage:number,mainPage:number) => {

        let dateFrom= DateHelper.dateObjectToDate(this.state.dateRange[0]);
        let dateTo= DateHelper.dateObjectToDate(this.state.dateRange[1]);
        let diffDays =Math.round((dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24));
        if(diffDays>this.state.maxDayRange){
            toast.error(`La busqueda no puede superar los ${this.state.maxDayRange} días`);
            return;
        }

        let request=this.getSettlementTransactionsRequest(false);
        if(lastSettlementNumber!=null)
            request.SettlementNumber=lastSettlementNumber+"";
        SettlementService.getSettlementTransactions(request).then((response: AxiosResponse<ISettlementTransaction[]>) => {
            if(!response || !response.data || response.data.length === 0) {
                this.setState({...this.state,
                    transactions: [],
                    errors: [],
                    activePage:activePage,
                    mainPage:mainPage,
                    doQuery:false,
                    conciliationTotalResponse: this.buildConciliationTotalsInitializationObject()
                })
                return;
            }
            const filteredTransactions = response.data;
            this.setState({...this.state,
                transactions: filteredTransactions,
                errors: [],
                activePage: activePage,
                mainPage: mainPage,
                doQuery: false
            },()=> {
                SettlementService.getConciliationTotals(request).then((concResponse: AxiosResponse<IConciliationTotalsResponse>) => {
                    this.setState({
                        ...this.state,
                        conciliationTotalResponse: concResponse.data
                    });
                });
            });
        }).catch(error => {
                this.setState({...this.state,
                errors: error.response.data,
                    activePage:activePage,
                    mainPage:mainPage,
                    doQuery:false
            });
                this.setState({...this.state,
                transactions: [],
                    activePage:activePage,
                    mainPage:mainPage,
                    doQuery:false
            })
            console.log('error:', error);
        }
        );
    }

    getSettlementsToExcel = async (): Promise<void> => {
        if (this.state.isCaptchaVerified) {
            this.setState(prevState => ({ ...prevState, showModalCaptcha: false }));
            this.messages.showDownloadMessage();
            SettlementService.getAllTransactionsToExcel(this.getSettlementTransactionsRequest(true)).then((response: AxiosResponse<Blob>) => {
            }).catch(error => {
                this.setState({...this.state,errors: error.response.data});
                console.log('error: ', error);
            });
        }else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        };
    }

    updateDateRange = (dateObject: DateObject[] | any) => {
        this.setState({ ...this.state, dateRange: dateObject });
    }

    onDateRangeTypeChange = (event: DateRangeType) => {
        this.buildColumnDefinition(event);
    }

    mergeTrx = (transaction:ISettlementTransaction)=> {
        this.setState({...this.state, paymentToMerge: transaction});
    }

    confirmMergeTrx=()=> {
        SettlementService.mergeTrx({ paymentId: this.state.paymentToMerge?.id, transactionId: this.state.trxToMerge }).then((response: any) => {
            toast.success("transactionMerged");
            this.setState({...this.state,paymentToMerge:null});
            window.location.href = "/conciliation/calendar";
        })
    }

    showMoreDetails = (transaction: ISettlementTransaction) => {
        this.setState({ showTransactionDetail: true, transactionDetail: transaction });
    }

    render() {
        // @ts-ignore
        const { t } = this.props;

        if(!this.props.show)
            return (<></>);
        else
            return (
                <Page>
                    <>
                        <Modal show={this.state.paymentToMerge!=null}>
                            <div className="card border p-0 pb-3">
                                <div className="card-header border-0 pt-3">
                                    <div className="card-options">
                                        <a href="javascript:void(0)" className="card-options-remove" onClick={() => this.setState({ paymentToMerge: null })} ><i className="fe fe-x"></i></a>
                                    </div>
                                </div>
                                <div className="card-body text-center">
                                    <span className=""><svg xmlns="http://www.w3.org/2000/svg" height="60" width="60"
                                        viewBox="0 0 24 24"><path fill="#f07f8f"
                                            d="M20.05713,22H3.94287A3.02288,3.02288,0,0,1,1.3252,17.46631L9.38232,3.51123a3.02272,3.02272,0,0,1,5.23536,0L22.6748,17.46631A3.02288,3.02288,0,0,1,20.05713,22Z" /><circle
                                            cx="12" cy="17" r="1" fill="#e62a45" /><path fill="#e62a45"
                                                d="M12,14a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v4A1,1,0,0,1,12,14Z" /></svg></span>
                                    <h4 className="h4 mb-0 mt-3">{t('warning')}</h4>
                                    <p className="card-text">{t('confirmMergeTrx')}</p>
                                </div>
                                <div className="card-footer text-center border-0 pt-0">
                                    <div className="row">
                                        <div className="text-center">
                                            <a className="btn btn-white me-2 cursor-pointer" onClick={() => this.setState({ paymentToMerge: null })}>{t('cancel')}</a>
                                            <a className="btn btn-danger cursor-pointer" onClick={() => this.confirmMergeTrx()}>{t('confirm')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <div className="vouchers">
                            <div className="row" >
                                <div className="col-lg-12">
                                    <div className="row">
                                        <div className="col-md-12 box-title">
                                           {!WebCache.isPosnetAppUser() && <h2>{t(`${T_PREFIX}paymentSchedule`)}</h2>}
                                        </div>
                                        <div className="col-md-12">
                                            {!WebCache.isPosnetAppUser() &&<p className="description">{t(`${T_PREFIX}description`)}</p>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-9 mt-2">
                                            <NavigationTabLinksForCalendar></NavigationTabLinksForCalendar>
                                        </div>
                                        <div className="col-lg-3 mt-2 d-flex align-items-center justify-content-end currency-filter-block">
                                            <span className='me-1 currency-label'>
                                                {t('currency')}
                                            </span>
                                            <CustomForm
                                                model={[this.state, this.setState.bind(this)]}>
                                                <SelectField attr='currencyFilter' label='' options={this.state.currencyOptions} ></SelectField>
                                            </CustomForm>
                                        </div>
                                    </div>
                                    {/*<div className='row'>
                                    <div className='col-lg-12'>
                                        <ErrorsView errors={[i18next.t("disclaimerSettlementTxt")]}/>
                                        <ErrorsView errors={this.state.errors}/>
                                    </div>
                                </div>
                                */}
                                    <div className="filter-accordion">
                                        <section hidden={this.props.settlementNumber != undefined}>
                                            <div className="row">
                                                <FormFilter hidden={true} model={[this.state, this.setState.bind(this)]}
                                                    onSubmit={() => this.getFromBuscar()}
                                                    clear={this.clearFilters}
                                                    isAllFilterAvailable={false}>
                                                    <>
                                                        {/*hidden={this.props.settlementNumber !== undefined}>*/}
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <DateField attr="dateRange" label="period" range></DateField>
                                                        </FilterBlock>
                                                        <FilterFiscalDocumentAndCommerce
                                                            merchantDocumentConfig={{
                                                                advancedClass: "col-md-12 my-4",
                                                                primaryClass: "col-md-2",
                                                                slot: 'primary'
                                                            }}
                                                            fiscalDocumentConfig={{
                                                                advancedClass: "col-md-12 my-4",
                                                                primaryClass: "col-md-2",
                                                                slot: 'primary'
                                                            }}
                                                            changeFilter={(fiscalDocument, merchantNumber) => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    filters: {
                                                                        ...this.state.filters,
                                                                        merchantNumber: merchantNumber,
                                                                        fiscalDocument: fiscalDocument
                                                                    }
                                                                });
                                                            }}
                                                            includeAllFiscalDocument={true}
                                                            includeWholesaler={true}
                                                            ref={this.multiSelectRef}
                                                        />
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <SelectField attr="brandFilter" label="brand"
                                                                options={this.optionMapper.translateOptionValues(this.state.brandOptions)}></SelectField>
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <SelectField attr="selectedStates" label="state"
                                                                options={this.state.allStates}></SelectField>
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4" className="hide-on-mobile-filter">
                                                            <SelectField attr="selectedMovementTypes" label="movementType"
                                                                options={this.state.movementTypes}></SelectField>
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <TextField
                                                                attr="settlementNumberFilter"
                                                                label={t(`${T_PREFIX}settlementNumber`)}
                                                            />
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <TextField
                                                                attr="batchFilter"
                                                                label={t(`${T_PREFIX}batch`)}
                                                            />
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <TextField
                                                                attr="authorizationCodeFilter"
                                                                label={t(`${T_PREFIX}authorizationCode`)}
                                                            />
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <TextField
                                                                attr="cardNumberFilter"
                                                                label={t(`${T_PREFIX}cardNumber`)}
                                                            />
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <TextField
                                                                attr="amountFilter"
                                                                label={t(`${T_PREFIX}amount`)}
                                                            />
                                                        </FilterBlock>
                                                        <FilterBlock slot="primary" primaryClass="col-md-2" advancedClass="col-md-12 my-4">
                                                            <TextField
                                                                attr="quotasFilter"
                                                                label={t(`${T_PREFIX}quotas`)}
                                                            />
                                                        </FilterBlock>
                                                    </>
                                                </FormFilter>
                                            </div>
                                        </section>
                                        <div className="row pb-4 ms-1">
                                            <div className="col-md-2 div-info div-info-width-5 ms-md-5"
                                                style={{ textAlign: "start" }}
                                                hidden={!WebCache.GetConciliationData().conciliationEnabled}>
                                                <label className="form-label"> {t('conciliated')}</label>
                                                <label hidden={this.state.conciliationTotalResponse.conciliatedAmount == 0}
                                                    className="border-start-0 ms-0 amount-label">{
                                                        Intl.NumberFormat('es-UY', {
                                                            style: 'currency',
                                                            currency: "UYU"
                                                        }).format(this.state.conciliationTotalResponse.conciliatedAmount)
                                                    }</label>
                                                <label
                                                    hidden={this.state.conciliationTotalResponse.conciliatedAmountUSD == 0}
                                                    className="border-start-0 ms-0 amount-label">{
                                                        Intl.NumberFormat('es-UY', {
                                                            style: 'currency',
                                                            currency: "USD"
                                                        }).format(this.state.conciliationTotalResponse.conciliatedAmountUSD)
                                                    }</label>
                                            </div>
                                            <div className="col-md-2 div-info div-info-width-5 ms-md-5"
                                                style={{ textAlign: "start" }}
                                                hidden={!WebCache.GetConciliationData().conciliationEnabled}>
                                                <label className="form-label"> {t('state')}</label>
                                                <label className="border-start-0 ms-0 amount-label">
                                                    {`${Intl.NumberFormat('es-UY', { maximumFractionDigits: 0 }).format(Number(this.state.conciliationTotalResponse.conciliatedPerc * 100))}%`}
                                                </label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                                <div className="col-md-12 px-0 py-5 accordion-table accordion-table-tax">
                                                    <SmartTable
                                                        key={this.state.dateRangeType}
                                                        data={this.state.transactions}
                                                        columnDefinitions={this.columnDefinitions}
                                                        config={{
                                                            pageSize: pageSize,
                                                            blockSize: (pageSize * pageQuantity),
                                                            mode: "grid",
                                                            paginator: {
                                                                quantity: pageQuantity,
                                                                mainPage: this.state.mainPage,
                                                                modifyMainPage: (value: number) => {
                                                                    this.setState({
                                                                        mainPage: this.state.mainPage + value
                                                                    }, () => this.getSettlementTransactions(null, this.state.activePage, this.state.mainPage))
                                                                },
                                                                pageRequest: this.state.pageRequest
                                                            },
                                                            defaultColumns: [
                                                                this.state.dateRangeType === 'PAYMENT_DATE' ? 'vtoDate'
                                                                    : this.state.dateRangeType === 'PRESENTATION_DATE' ? 'aggregationPresentationDate'
                                                                    : 'authDate',
                                                                "batch", "ticket", "cardNumber", "productCode", "grossAmount", "terminal", "currency"
                                                            ],
                                                            storageKey: 'smart-table:payment-transaction-report',
                                                            title: t(`shared.smartTable.couponsTitle`),
                                                            isCustomizeTableAvailable: false
                                                        }}
                                                        onDownload={() => this.setState({ ...this.state, showModalCaptcha: true })}
                                                        dateRangeType={this.props.settlementNumber == undefined ? (
                                                            <CustomForm model={[this.state, this.setState.bind(this)]}>
                                                                <RadioButtonGroup
                                                                    model={[this.state, this.setState.bind(this)]}
                                                                    attr="dateRangeType"
                                                                    className='radioStyle'
                                                                    fieldDefinitions={[
                                                                        { key: 'originalPresentationDate', value: 'PAYMENT_DATE', label: 'settlement-vtoDate' },
                                                                        { key: 'authDate', value: 'OPERATION_DATE', label: 'settlement-authDate' },
                                                                        { key: 'aggregationPresentationDate', value: 'PRESENTATION_DATE', label: 'settlement-aggregationPresentationDate' }
                                                                    ]}
                                                                    onChange={(event: ChangeEvent<HTMLInputElement>) => this.onDateRangeTypeChange(event.target.value as DateRangeType)}
                                                                />
                                                            </CustomForm>
                                                        ) : undefined}
                                                    ></SmartTable>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.showModalCaptcha && (
                                <Modal show centered backdrop="static" contentClassName='captcha-modal-content' onHide={() => {
                                    this.setState({ ...this.state, showModalCaptcha: false, isCaptchaVerified: false });
                                }}
                                >
                                    <Modal.Body className='captcha-modal-body'>
                                        <h5 className='text-center mb-2'>
                                            Estás por descargar los resultados de búsqueda
                                        </h5>
                                        <p className='text-center mb-3'>
                                            Por seguridad, necesitamos que completes el reCAPTCHA para continuar.
                                        </p>
                                        <div className='d-flex justify-content-center mb-3'>
                                            <div className='captcha-container'>
                                                <CustomReCAPTCHA useCache={true} onVerify={(v: boolean) => this.setState(prevState => ({ ...prevState, isCaptchaVerified: v }))} />
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-center'>
                                            <div className='captcha-actions'>
                                                <Button color='white' noMargin label="Cancelar" onClick={() => {
                                                    this.setState({ ...this.state, showModalCaptcha: false, isCaptchaVerified: false });
                                                }}
                                                ></Button>
                                                <Button color='primary' noMargin label="Continuar" disabled={!this.state.isCaptchaVerified} onClick={this.getSettlementsToExcel}
                                                ></Button>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            )}
                            <SideModal
                                title={t(`${T_PREFIX}detailTransactionTitle`)}
                                show={this.state.showTransactionDetail}
                                onClose={() => this.setState({ showTransactionDetail: false, transactionDetail: null })}
                            >
                                {this.state.transactionDetail && <DetailPaymentTransactionReport transaction={this.state.transactionDetail} t={t} />}
                            </SideModal>
                        </div>
                    </>
                </Page>
            )
    };
}

export default withMessages(withTranslation()(PaymentTransactionReport));
